import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Typography, Chip } from '@mui/material';
import { Storage as DataIcon } from '@mui/icons-material';

const DataNode = ({ data, isConnectable, selected }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        minWidth: '160px'
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        style={{
          background: '#7C3AED',
          width: 10,
          height: 10,
          border: '2px solid #fff'
        }}
      />
      
      {/* Parallelogram shape for data */}
      <Box
        sx={{
          padding: '12px 16px',
          background: selected 
            ? 'linear-gradient(45deg, #8B5CF6 30%, #A78BFA 90%)' 
            : 'linear-gradient(45deg, #8B5CF6 30%, #7C3AED 90%)',
          color: 'white',
          transform: 'skew(-15deg)',
          borderRadius: '6px',
          boxShadow: selected 
            ? '0 4px 20px rgba(139, 92, 246, 0.4)' 
            : '0 2px 15px rgba(139, 92, 246, 0.2)',
          border: selected ? '2px solid #7C3AED' : 'none',
          transition: 'all 0.2s ease',
          '&:hover': {
            boxShadow: '0 4px 25px rgba(139, 92, 246, 0.3)',
            transform: 'skew(-15deg) translateY(-2px)'
          }
        }}
      >
        {/* Content inside (un-skewed) */}
        <Box
          sx={{
            transform: 'skew(15deg)',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5
          }}
        >
          <DataIcon sx={{ fontSize: 22 }} />
          <Box sx={{ flexGrow: 1 }}>
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: 600,
                fontSize: '0.9rem'
              }}
            >
              {data.label}
            </Typography>
            {data.description && (
              <Typography 
                variant="caption" 
                sx={{ 
                  opacity: 0.9,
                  display: 'block',
                  mt: 0.5,
                  fontSize: '0.7rem',
                  lineHeight: 1.2
                }}
              >
                {data.description}
              </Typography>
            )}
          </Box>
        </Box>

        {/* Data type indicator */}
        <Box 
          sx={{ 
            mt: 1, 
            display: 'flex', 
            justifyContent: 'flex-end',
            transform: 'skew(15deg)'
          }}
        >
          <Chip 
            label="Data" 
            size="small" 
            sx={{ 
              backgroundColor: 'rgba(255,255,255,0.2)',
              color: 'white',
              fontSize: '0.6rem',
              height: 18
            }} 
          />
        </Box>
      </Box>
      
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        style={{
          background: '#7C3AED',
          width: 10,
          height: 10,
          border: '2px solid #fff'
        }}
      />
    </Box>
  );
};

export default memo(DataNode);